import React, { Component, useState } from "react";
import { render } from "react-dom";
import PlaysListD from "./PlaysListDesktop";
import PlaysList from "./PlaysListMobile";
import { useMediaQuery } from 'react-responsive'


export default function PlaysListResponsive(){
    const isMobileDevice = useMediaQuery({
        query: "(max-width: 48em)",
      });

  return(
      <div>
        {!isMobileDevice && <PlaysListD/>}
        {isMobileDevice && <PlaysListD/>}  
      </div>
    )
}

